import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import Colors from '@components/shared/Colors';
import {
  CERTIFICATION_ISO_13485,
  CERTIFICATION_B_CORP,
  CERTIFICATION_GOTS,
  CERTIFICATION_GMP,
  CERTIFICATION_CLIMATE_PARTNER,
  CERTIFICATION_A21
} from '@constants';
import Logos from './Logos';

type Props = {};

const Certifications: React.FC<Props> = () => {
  const { t } = useTranslation();
  const logoImages = [CERTIFICATION_ISO_13485, CERTIFICATION_B_CORP, CERTIFICATION_GOTS, CERTIFICATION_GMP, CERTIFICATION_CLIMATE_PARTNER];

  return (
    <Logos
      background={Colors.mint50}
      title={t('components.environmentally-friendly')}
      logos={logoImages}
      highlightedLogoImage={CERTIFICATION_A21}
      highlightedLogoText={t('components.a21-certification-text')}
    />
  );
};

export default Certifications;
